module.exports = __webpack_public_path__ + "static/media/orangeCross.772e9fc5.png";